const ServiceCalls = {
	getSupplier: async function (supplierId) {
		return makePostCall("/Supplier/GetSupplier", "application/json", supplierId);
	},
	updateSupplier: async function (supplierId, supplierStatus) {
        var supplierObj = {
            supplierId: supplierId,
            enabled: supplierStatus,
        };
		return makePostCall("/Supplier/UpdateSupplier", "application/json", supplierObj);
	},
	getSupplierAdmin: async function (supplierId) {
		return makePostCall("/Contacts/GetSupplierAdmin", "application/json", supplierId);
	},
	updateSupplierAdmin: async function (updatedUser) {
		return makePostCall("/Contacts/UpdateAdminStatus", "application/json", updatedUser);
	},
	getAdditionalUsers: async function (supplierId) {
		return makePostCall("/Contacts/GetAdditionalUsers", "application/json", supplierId);
	},

	getSupplierContact: async function (contactId, supplierId, allProfiles = false) {
		var contactObj = {
			contactId: contactId,
			supplierId: supplierId,
		};
		const queryParam = allProfiles ? '?allProfiles=true' : '';
		return makePostCall(`/Contacts/GetSupplierContact${queryParam}`, "application/json", contactObj);
	},
	updateSupplierUser: async function (userData) {
		return makePostCall("/Contacts/UpdateUser", "application/json", userData);
	},
	addContact: async function (newUser) {
		return makePostCall("/Contacts/CreateContact", "application/json", newUser);
	},
	getOHCIDInvite: async function (email) {
		return makePostCall("OHCID/GetInvite", "application/json", email);
	},
	resendOHCIDInvite: async function (email) {
		return makePostCall("/OHCID/ResendInvite", "application/json", email);
	},
	createOHCIDInvite: async function (email) {
		return makePostCall("/OHCID/CreateInvite", "application/json", email);
	},
	cancelOHCIDInvite: async function (email, supplierId) {
		var cancelInviteObj = {
			email: email,
			supplierId: supplierId,
		};
		return makePostCall("OHCID/CancelInvite", "application/json", cancelInviteObj);
	},
	getSearchResults(searchData) {
		return makePostCall("/search/InquirySearch", "application/json", searchData);
	},
	getAllSearchResults(searchData) {
		searchData["fetchAll"] = true;
		return makePostCall("/search/InquirySearch", "application/json", searchData);
	},
	exportSearchResultsToExcel(searchData, isEMEASearch) {
		searchData["fetchAll"] = true;
		searchData["performEMEASeach"] = isEMEASearch;
		return makeFileCall("/search/ExportSearchResultsToExcel", searchData);
	},
	exportSearchResultsToCSV(searchData,isEMEASearch) {
		searchData["fetchAll"] = true;	
		searchData["performEMEASeach"] = isEMEASearch;
		return makeFileCall("/search/ExportSearchResultsToCSV", searchData);
	},
	checkSupplierAccess(supplierId) {
		return makePostCall("/Supplier/CheckAccess", "application/json", supplierId);
	},
	checkVendorAccess(supplierId) {
		return makePostCall("/Vendor/CheckAccess", "application/json", supplierId);
	},
	setCurrentSupplier(supplierId) {
		return makePostCall("/Supplier/SetSupplierId", "application/json", supplierId);
	},
	checkAdminAccess() {
		return makeGetCall("/Supplier/CheckAdminAccess", "application/json");
	},
	getActiveSiteNotifications() {
		return makeGetCall("/Admin/GetActiveNotifications", "application/json");
	},
	getRecentNotifications(notificationCount) {
		return makePostCall("/Admin/GetRecentNotifications", "application/json", notificationCount);
	},
	addSiteNotification(data) {
		return makePostCall("/Admin/AddNotification", "application/json", data);
	},
	deleteSiteNotification(data) {
		return makeDeleteCall("Admin/DeleteNotification", "application/json", data);
	},
	updateSiteNotification(data) {
		return makePostCall("/Admin/UpdateNotification", "application/json", data);
	},
	hideNotification() {
		return makeGetCall("/Admin/DisableVisibility", "application/json");
	},
	deleteNotification(notificationId) {
		return makePostCall("/Admin/DeleteNotification", "application/json", notificationId);
	},
	getAdminAccessResults(searchString) {
		return makePostCall("/Admin/GetAdminAccessResults", "application/json", searchString);
	},
	getAdminAuditResults(data) {
		return makePostCall("/Admin/GetAdminAuditResults", "application/json", data);
	},
	getOMSToken() {
		return makeGetCall("/Messaging/GetOMSBearerToken", "application/json");
	},
	getOMSMailbox() {
		return makeGetCall("/Messaging/GetMailbox", "application/json");
	},
	createOMSMailbox() {
		return makePutCall("/Messaging/CreateMailbox", "application/json");
	},
	extendLogin() {
		return makeGetCall("/Auth/ExtendLogin", "application/json");
	},
	idleLogout() {
		return makeGetCall("/Auth/IdleLogout", "application/json");
	},
	postAuditLog(data) {
		return makePostCall("/Admin/AddAuditLog", "application/json", data);
	},
	postDiagnosticLog(data) {
		return makePostCall("/Admin/AddDiagnosticLog", "application/json", data);
	},
	getPolicyVersions(policyCount) {
		return makePostCall("/Admin/GetPolicyVersions", "application/json", policyCount);
	},
	addPolicyVersion(data) {
		return makePostCall("/Admin/AddPolicyVersion", "application/json", data);
	},
	onUserAttestation() {
		return makePutCall("/Auth/CreateUserAttestation", "application/json");
	},
	getVendorInfo(supplierId) {
		return makePostCall("/Vendor/GetVendorInfo", "application/json", supplierId);
	},
	getVendorCountries() {
		return makeGetCall("/Vendor/GetCountries", "application/json");
	},
	getVendorCountry(countryCode) {
		return makePostCall("/Vendor/GetCountry", "application/json", countryCode);
	},
	getVendorRegions(country) {
		return makePostCall("/Vendor/GetRegions", "application/json", country);
	},
	getVendorRegion(regionDetails) {
		return makePostCall("/Vendor/GetRegion", "application/json", regionDetails);
	},
	updateVendorContact(vendorContact) {
		return makePostCall("/Vendor/UpdateVendorContact", "application/json", vendorContact);
	},
	updateVendorAddress(vendorAddress) {
		return makePostCall("/Vendor/UpdateVendorAddress", "application/json", vendorAddress);
	},
	updateVendorAddresses(vendorAddresses) {
		return makePostCall("/Vendor/UpdateVendorAddresses", "application/json", vendorAddresses);
	},
	getAddressPendingPayments(supplierId, addressSeqNum, addressLocations) {
		var addressObj = {
			supplierId: supplierId,
			addressSeqNum: addressSeqNum,
			addressLocations: addressLocations,
		};
		return makePostCall("/Vendor/GetAddressPendingPayments", "application/json", addressObj);
	},
	sendFileAttachment(attachInfo) {
		return makeFormCall("/Vendor/SendFileAttachment", attachInfo);
	},
	addAttachment(attachInfo) {
		return makeFormCall("/Vendor/AddAttachment", attachInfo);
	},
	deleteAttachment: async function (storageUrl) {
		return makeDeleteCall("/Vendor/DeleteAttachment", "application/json", storageUrl);
	},
	downloadAttachment(attachInfo) {
		return makeFileCall("/Vendor/DownloadFile", attachInfo);
	},
	submitBankRequest(bankRequest) {
		return makePostCall("/Vendor/SubmitBankRequest", "application/json", bankRequest);
	},
	getEarlyWarningScore(bankRequest) {
		return makePostCall("/Vendor/GetEarlyWarningScore", "application/json", bankRequest);
	},
	resubmitEarlyWarningScore(wfRequest) {
		return makePostCall("/Vendor/ResubmitEarlyWarningScore", "application/json", wfRequest);
	},
	getWorklistItems(supplierId, getAllRequests) {
		var requestObj = {
			supplierId: supplierId,
			getAllRequests: getAllRequests,
		};
		return makePostCall("/Vendor/GetWorklistRequests", "application/json", requestObj);
	},
	getBankRequestById(supplierId, bankRequestId) {
		var requestObj = {
			supplierId: supplierId,
			bankRequestId: bankRequestId,
		};
		return makePostCall("/Vendor/GetBankRequestById", "application/json", requestObj);
	},
	approveBankRequest(vendorRecordId, bankRequestId) {
		var requestObj = {
			vendorRecordId: vendorRecordId,
			bankRequestId: bankRequestId
		};
		return makePostCall("/Vendor/ApproveBankRequest", "application/json", requestObj);
	},
	rejectBankRequest(rejectData) {
		return makePostCall('/Vendor/RejectBankRequest', 'application/json', rejectData);
	},
	updateBankRequest(vendorRecordId, bankRequestId, newStatusId) {
		var requestObj = {
			vendorRecordId: vendorRecordId,
			bankRequestId: bankRequestId,
			newStatusId: newStatusId,
		};
		return makePostCall("/Vendor/UpdateBankRequest", "application/json", requestObj);
	},
	getBankRequestNotifications(supplierId) {
		return makePostCall("/Vendor/GetBankRequestNotifications", "application/json", supplierId);
	},
	setBankRequestNotificationViewed(requestId) {
		return makePostCall("/Vendor/SetBankRequestNotificationViewed", "application/json", requestId);
	},
	addBankRequestComment(comment) {
		return makePostCall("/Vendor/CreateBankRequestComment", "application/json", comment);
	},
	checkWorklistAccess(supplierId) {
		return makePostCall("/Vendor/CheckWorklistAccess", "application/json", supplierId);
	},
	checkProfileAccess(supplierId) {
		return makePostCall("/Supplier/CheckProfileAccess", "application/json", supplierId);
	},
	getSiteUsage(numMonths, currentAudience) {
		var requestObj = {
			MonthsToDisplay: numMonths,
			Audience: currentAudience
		};
		return makePostCall("/Admin/GetSiteUsage", "application/json", requestObj);
	},
	getSiteUsagePerYear(currentAudience) {
		return makePostCall("/Admin/GetSiteUsagePerYear", "application/json",currentAudience);
	},
	getSiteAudits(numMonths, currentAudience) {
		var requestObj = {
			MonthsToDisplay: numMonths,
			Audience: currentAudience
		};
		return makePostCall("/Admin/GetAuditsForMonth", "application/json", requestObj);
	},
	getVendorSetIDList(showGlobalOption, showAdminOption) {	
		var requestObj = {
			showGlobalOption: showGlobalOption,
			showAdminOption: showAdminOption
		};
		return makePostCall("/Admin/GetVendorSetIDList", "application/json", requestObj);
	},
	isVendorEMEA(vendorRecordId) {
		return makePostCall("/Vendor/IsEMEAVendor", "application/json", vendorRecordId); 
	},
	getSiteLogins() {
		return makeGetCall("/Admin/GetSiteLogins", "application/json"); 
	},
	getAdminInactiveAccounts(searchInfo) {
		return makePostCall("/Admin/GetInactiveAccounts", "application/json", searchInfo || {});
	},
	getSupplierAdminComments(supplierId) {
		return makePostCall("/Admin/GetSupplierAdminComments", "application/json", supplierId); 
	},
	addSupplierComment(adminSupplierInfoObj) {
		return makePostCall("/Admin/AddSupplierAdminComments", "application/json", adminSupplierInfoObj);
	},
	getOMSUnreadCount(mid) {		
		console.log(`In getOMSUnreadCount - MID: ${mid}`);
		return makePostCall("/Messaging/GetUnreadMailCount", "application/json", mid);
	},
};
function makeGetCall(url, contentType) {
	return makeCallNoBody(url, "GET", contentType);
}
function makePostCall(url, contentType, body) {
	return makeCall(url, "POST", contentType, body);
}
function makePutCall(url, contentType) {
	return makeCallNoBody(url, "PUT", contentType);
}
function makeDeleteCall(url, contentType, body) {
	return makeCall(url, "DELETE", contentType, body);
}

async function makeCallNoBody(url, method, contentType) {
	var csrfToken = "";
	if (method !== "GET") {
		var response = await fetch("/Auth/GetToken", {
			method: "GET",
		});
		csrfToken = getCookie(response);
	}

	const result = await fetch(url, {
		method: method,
		mode: 'cors',
		redirect: 'manual',
		credentials: 'include',
		headers: {
			"Content-Type": contentType,
			"X-XSRF-TOKEN": csrfToken
		}
	})
		.then(function (response) {
			try {
				if (response.ok && response.status >= 200 && response.status < 300) {
					return response.json();
				} else if (response.type === "opaqueredirect") {
					console.log(`In makeCallNoBody - Redirect happening to ${response.url}`)
					window.location.href = `/auth/login?ReturnURL=${window.location.pathname}`; //response.url;
				}
				else {
					var respTxt = response.text();
					console.error(`In makeCallNoBody - Invalid Result from Server Response: ${respTxt}`);
				}
			} catch (e) {
				//Response is not JSON
				//var respTxt = res.text();
				console.error(`In makeCallNoBody - Error returned from server ${e}`);
				return "";
			}
		})
		.then((json) => {
			return json;
		})
		.catch((err) => {
			console.error(`In makeCallNoBody - Error making call to ${url} via makeCall  Ex: ${err}`);
		});
	return result;
}
async function makeCall(url, method, contentType, body) {
	var csrfToken = '';
    try {
		var response = await fetch("/Auth/GetToken", {
			method: "GET",
		});
		csrfToken = getCookie(response); 

	const result = await fetch(url, {
		method: method,
		mode: 'cors',
		redirect: 'manual',
		credentials: 'include',
		headers: {
			"Content-Type": contentType,
			"X-XSRF-TOKEN": csrfToken
		},
		body: JSON.stringify(body),
	})
		.then(function (response) {
			try {
				if (response.ok && response.status >= 200 && response.status < 300) {
					return response.json();
				} else if (response.type === "opaqueredirect") {
					console.log(`Redirect happening to ${response.url}`)
					window.location.href = `/auth/login?ReturnURL=${window.location.pathname}`;
				}
				else {
					var respTxt = response.text();
					console.error(`In makeCall - Invalid Result from Server Response: ${respTxt}`);
				}
			} catch (e) {
				//Response is not JSON			
				console.error(`In makeCall - Error returned from server ${e}`);
				return "";
			}
		})
		.then((json) => {
			return json;
		})
		.catch((err) => {
			console.error(`MAIN - Error making call to ${url} via makeCall  Ex: ${err}`);
		});
		return result;
	} catch (tokenErr) {
		window.location.href = `/auth/login?ReturnURL=${window.location.pathname}`;
	}

}
async function makeFileCall(url, body) {
	var csrfToken = '';
	try {
		var response = await fetch("/Auth/GetToken", {
			method: "GET",
		});
		csrfToken = getCookie(response);

	const result = await fetch(url, {
		method: "POST",
		mode: 'cors',
		redirect: 'manual', // manual, *follow, error'
		credentials: 'include',
		responseType: "blob",
		headers: {
			"Content-Type": "application/json",
			"X-XSRF-TOKEN": csrfToken
		},
		body: JSON.stringify(body),
	})
		.then(function (response) {
			try {
				if (response.ok && response.status >= 200 && response.status < 300) {
					return response.blob();
				} else if (response.type === "opaqueredirect") {
					console.log(`In makeFileCall - Redirect happening to ${response.url}`)
					window.location.href = `/auth/login?ReturnURL=${window.location.pathname}`;
				}
				else {
					var respTxt = response.text();
					console.error(`In makeFileCall - Invalid Result from Server Response: ${respTxt}`);
				}
			} catch (e) {
				//Response is not JSON
				//var respTxt = res.text();
				console.error(`In makeFileCall  - Error returned from server ${e}`);
				return "";
			}
		})

		.catch((err) => {
			console.error(`Error making call to ${url} via makeFileCall Ex: ${err}`);
			// throw new Error(err);
		});
	return result;
} catch (tokenErr) {
	window.location.href = `/auth/login?ReturnURL=${window.location.pathname}`;
}
}
async function makeFormCall(url, fData) {
	var csrfToken = '';
	try {
		var response = await fetch("/Auth/GetToken", {
			method: "GET",
		});
		csrfToken = getCookie(response);
	const result = await fetch(url, {
		method: "POST",
		body: fData,
		mode: 'cors',
		redirect: 'manual', // manual, *follow, error'
		credentials: 'include',
		headers: {
			"X-XSRF-TOKEN": csrfToken
		}
	})
		.then(function (response) {
			try {
				if (response.ok && response.status >= 200 && response.status < 300) {
					return response.json();
				} else if (response.type === "opaqueredirect") {
					console.log(`In makeFormCall - Redirect happening to ${response.url}`)
					window.location.href = `/auth/login?ReturnURL=${window.location.pathname}`;
				}
				else {
					var respTxt = response.text();
					console.error(`In makeFormCall - Invalid Result from Server Response: ${respTxt}`);
				}
			} catch (e) {
				//Response is not JSON
				//var respTxt = res.text();
				console.error(`In makeFormCall - Error returned from server ${e}`);
				return "";
			}
		})

		.catch((err) => {
			console.error(`In makeFormCall - Error making call to ${url} via makeFormCall Ex: ${err}`);
			// throw new Error(err);
		});
	return result;
	} catch (tokenErr) {
		window.location.href = `/auth/login?ReturnURL=${window.location.pathname}`;
	}
}

function getCookie(resp) {
	if (resp.ok) {
		//var winCook = (window.document) ? Window.document.cookieStore.getCookie("XSRF-TOKEN") :"";
		var respCook = (resp) ? resp.headers.get("requestverificationtoken") : "";
		if (respCook) {
			return respCook;
		}
		for (const value of resp.headers.entries()) {
			console.log('yay', value);
		}

		for (const value of resp.headers.values()) {
			console.log('val', value);
		}
		if (!document.cookie) {
			return null;
		}
		const csrfCookies = document.cookie.split(';')
			.map(c => c.trim())
			.filter(c => c.startsWith("XSRF-TOKEN="));
		if (csrfCookies.length === 0) {
			return null;
		}
		return decodeURIComponent(csrfCookies[0].split('=')[1]);
	}
	else {
		console.log('No Token');
		return '';
	}
}
export default ServiceCalls;
